import type { TechniqueEntry } from '../schema';

// review: candidate draft — the doc flags it as the thinnest of the candidates; genuine clinical
// origination required, not just sign-off.
export const stressCravingCycle: TechniqueEntry = {
  key: 'stress_craving_cycle',
  version: '0.1-candidate',
  name: 'Stress-craving cycle',
  pillar: 'CBT',
  serves:
    "Making the member's own stress→craving loop visible (tension feeds the urge, the use relieves it briefly, and the relief trains the loop tighter), mapped to their week, never taught as theory.",
  method: [
    'Start from their material: a stressful stretch they have already described.',
    'Draw the loop in their own instances: the stress, the signal, the use, the short relief, the return with interest (the sleep, the next morning, the guilt).',
    'Offer the cycle framing once and let them place themselves on it, correcting it toward their reality.',
    'Close by finding the one interception point that feels widest to them (where the loop seems most interruptible) and leave it named, not planned.',
  ],
  never: [
    'Never as a lecture: their instances or nothing.',
    'Never turn the interception point into a plan in the same breath (planning is its own move, separately gated).',
    'Never assert the loop where their account does not show it.',
    'Physical signals that read as withdrawal (shaking, sweating when stopping) are safety and screening territory, never cycle material; route per the safety protocol, and never explain them medically (the constraints bar withdrawal-risk information; redirect warmly to their doctor).',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'Stress and use both already in the room, in their words.',
    },
  ],
  doneWhen:
    'The member describes the loop in their own life unprompted ("so when X happens, I…") and names where it feels interruptible.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'Intake preview naming (promised to members); catalog A4 rationale (the science of urges); NIAAA CBI §5.3b/§5.3e (emotions — including positive ones — as internal triggers; physical feelings "often misattributed" as craving when the real cause is stress, fatigue, blood sugar, caffeine).',
};
